import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Icon } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const NavItem = ({ icon, to, children, ...rest }) => {
  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        _hover={{
          bg: 'cyan.400',
          color: 'white',
        }}
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: 'white',
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Link>
  );
};

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  icon: PropTypes.func,
};

NavItem.defaultTypes = {
  icon: undefined,
};

export default NavItem;
